import NextIconDark from '@Resources/assets/icons/dark/nextVertical.svg';
import ResetIconDark from '@Resources/assets/icons/dark/pan.svg';
import PrevIconDark from '@Resources/assets/icons/dark/prevVertical.svg';
import ExpandIconDark from '@Resources/assets/icons/dark/punchIn.svg';
import CollapseIconDark from '@Resources/assets/icons/dark/punchOut.svg';
import ZoomInIconDark from '@Resources/assets/icons/dark/zoomIn.svg';
import ZoomOutIconDark from '@Resources/assets/icons/dark/zoomOut.svg';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import IconBtn from '@Components/IconButton/IconButton';
import IconBtnStyles from '@Components/IconButton/IconButton.scss';

const EntityImageControls = (props) => {
    const {
        onNext,
        onPrev,
        onZoomIn,
        onZoomOut,
        onExpand,
        onCollapse,
        onResetZoom,
        hideSelectControls,
        selectedImgIndex,
    } = props;

    return (
        <React.Fragment>
            <div
                className={IconBtnStyles.iconBtnGroup}
                style={{ marginRight: '10px' }}
            >
                {onExpand && (
                    <IconBtn
                        id="entity-img-expand-btn"
                        onClick={() => onExpand(selectedImgIndex)}
                        icon={
                            <SvgIcon inheritViewBox>
                                <ExpandIconDark />
                            </SvgIcon>
                        }
                    />
                )}

                {onCollapse && (
                    <IconBtn
                        id="entity-img-collapse-btn"
                        onClick={() => onCollapse(selectedImgIndex)}
                        icon={
                            <SvgIcon inheritViewBox>
                                <CollapseIconDark />
                            </SvgIcon>
                        }
                    />
                )}

                <IconBtn
                    id="entity-img-zoom-in-btn"
                    onClick={onZoomIn}
                    icon={
                        <SvgIcon inheritViewBox>
                            <ZoomInIconDark />
                        </SvgIcon>
                    }
                />
                <IconBtn
                    id="entity-img-zoom-out-btn"
                    onClick={onZoomOut}
                    icon={
                        <SvgIcon inheritViewBox>
                            <ZoomOutIconDark />
                        </SvgIcon>
                    }
                />
                <IconBtn
                    id="entity-img-reset-zoom-btn"
                    onClick={onResetZoom}
                    icon={
                        <SvgIcon inheritViewBox>
                            {' '}
                            <ResetIconDark />
                        </SvgIcon>
                    }
                />
            </div>
            {!hideSelectControls && (
                <div className={IconBtnStyles.iconBtnGroup}>
                    <IconBtn
                        id="main-img-prev-btn"
                        onClick={onPrev}
                        icon={
                            <SvgIcon inheritViewBox>
                                <PrevIconDark />
                            </SvgIcon>
                        }
                    />
                    <IconBtn
                        id="main-img-next-btn"
                        onClick={onNext}
                        icon={
                            <SvgIcon inheritViewBox>
                                <NextIconDark />
                            </SvgIcon>
                        }
                    />
                </div>
            )}
        </React.Fragment>
    );
};

EntityImageControls.propTypes = {
    onNext: PropTypes.func,
    onPrev: PropTypes.func,
    onZoomIn: PropTypes.func,
    onZoomOut: PropTypes.func,
    onExpand: PropTypes.func,
    onCollapse: PropTypes.func,
    onResetZoom: PropTypes.func,
    hideSelectControls: PropTypes.bool,
    selectedImgIndex: PropTypes.number,
};
export default EntityImageControls;
